import gql from 'graphql-tag';
//agregar fecha de vigencia para apis
export const queryCliente = gql`
   query Cliente($codigoCliente: String!) {
      clienteSpu(codigo: $codigoCliente) {
         codigo
         ruc
         razonSocial
         iter
         usuario
         tipoDoc
         serieDoc
         nroDoc
         anio
         fechaExpiracion
         fechaVigenciaApi
         producto
         version
         presentacion
         modular
      }
   }
`;
